import { SvgIconProps } from "../types";

// alt defaults to "" so purely decorative icons (e.g. inside labelled links) are skipped by screen readers.
export const SvgIcon = ({ src, width, height, alt = "" }: SvgIconProps) => (
  <img src={`/img/svg/${src}`} alt={alt} width={width} height={height} />
);
